class GPNewsletterSignup extends HTMLElement {
  connectedCallback() {
    if (this.form) return;

    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[data-newsletter-submit]');
    this.status = this.querySelector('[data-newsletter-status]');
    if (!this.form || !this.submitButton || !this.status) return;

    this.idleLabel = this.submitButton.textContent.trim();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    this.form = null;
    this.submitButton = null;
    this.status = null;
    this.handleSubmit = null;
    this.submitting = false;
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.submitting || !this.form.reportValidity()) return;

    this.submitting = true;
    this.setBusy(true);
    this.setStatus(this.dataset.pendingMessage, 'pending');

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams(new FormData(this.form)),
        credentials: 'omit',
        mode: 'cors',
      });
      const payload = await response.json().catch(() => null);

      if (!response.ok || payload?.ok !== true) {
        throw new Error('Newsletter signup was not accepted.');
      }

      this.form.reset();
      this.setStatus(this.dataset.successMessage, 'success');
    } catch (_error) {
      this.setStatus(this.dataset.errorMessage, 'error');
    } finally {
      this.submitting = false;
      this.setBusy(false);
    }
  }

  setBusy(isBusy) {
    this.form.setAttribute('aria-busy', String(isBusy));
    this.submitButton.disabled = isBusy;
    this.submitButton.textContent = isBusy ? this.dataset.pendingButtonLabel : this.idleLabel;
  }

  setStatus(message, state) {
    this.form.dataset.state = state;
    this.status.dataset.state = state;

    if (state !== 'success') {
      this.status.textContent = message;
      this.status.hidden = false;
      return;
    }

    const sentence = message.match(/^(.+?[.!?。！？])\s*(.*)$/u);
    const heading = document.createElement('strong');
    heading.className = 'gp-newsletter__success-heading';
    heading.textContent = sentence ? sentence[1].replace(/[.!?。！？]$/u, '') : message;

    const content = [heading];
    if (sentence?.[2]) {
      const detail = document.createElement('p');
      detail.className = 'gp-newsletter__success-detail';
      for (const part of sentence[2].split(/(10%\s+welcome offer|on its way)/gi)) {
        if (!part) continue;
        if (/^(10%\s+welcome offer|on its way)$/i.test(part)) {
          const emphasis = document.createElement('strong');
          emphasis.textContent = part;
          detail.append(emphasis);
        } else {
          detail.append(document.createTextNode(part));
        }
      }
      content.push(detail);
    }

    this.status.replaceChildren(...content);
    this.status.hidden = false;
  }
}

if (!customElements.get('gp-newsletter-signup')) {
  customElements.define('gp-newsletter-signup', GPNewsletterSignup);
}
